import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from '../pages/auth/LoginPage';
import ListPage from '../pages/news/ListPage';
import DetailsPage from '../pages/news/DetailsPage';
import SalesReportPage from '../pages/reports/SalesReportPage';
import NetPriceReport from '../pages/reports/NetPriceReportPage';
import AccountMultiplierForm from '../pages/account-multiplier/AccountMultiplierFormPage';
import TerritoryMultiplierReport from '../pages/territory-multiplier-report/TerritoryMultiplierReportPage.jsx';
import SalesTrendingReportPage from '../pages/sales-trending-report/index';
import TechtopTrainingPage from '../pages/techtop-training/index';
import DistributorLookupPage from '../pages/distributor-lookup/index';
import StaticPage from '../pages/static-pages/index';
import BonusPage from '../pages/bonus/index';
import QuoteMePage from '../pages/quote-me/index';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import Default from '../pages/layouts/Default';
import { INDEX_URL } from '../utils/constants';

function AppRoutes() {
  return (
    <Router>
      <Routes>

        {/* Public route (e.g., Login) */}
        <Route
          path={`${INDEX_URL}`}
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />

        {/* Private routes go inside Default */}
        <Route
          path={`${INDEX_URL}`}
          element={
            <PrivateRoute>
              <Default />
            </PrivateRoute>
          }
        >
          <Route path={`${INDEX_URL}/dashboard`} element={<ListPage />} />
          <Route path={`${INDEX_URL}/sales-report`} element={<SalesReportPage />} />
          <Route path={`${INDEX_URL}net-price-report`} element={<NetPriceReport />} />
          <Route path={`${INDEX_URL}account-multiplier-form`} element={<AccountMultiplierForm />} />
          <Route path={`${INDEX_URL}/news-details/:permalink`} element={<DetailsPage />} />
          <Route path={`${INDEX_URL}/territory-multiplier-report`} element={<TerritoryMultiplierReport />} />
          <Route path={`${INDEX_URL}/sales-trending-report`} element={<SalesTrendingReportPage />} />
          <Route path={`${INDEX_URL}/quote-me`} element={<QuoteMePage />} />
          <Route path={`${INDEX_URL}/year-end-bonus`} element={<BonusPage />} />
          <Route path={`${INDEX_URL}/techtop-training`} element={<TechtopTrainingPage />} />
          <Route path={`${INDEX_URL}/distributor-lookup`} element={<DistributorLookupPage />} />
          <Route path={`${INDEX_URL}/csr-open-orders`} element={<StaticPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default AppRoutes;